var format = require("date-format");
const formatDate4Input = (datum) => {
  let newDate = new Date(datum);
  let formattedDate = datum ? (newDate ? format("yyyy-MM-dd", newDate) : "") : datum;
  // console.log(formattedDate);
  return formattedDate;
};
export default formatDate4Input;
